import { useForcePasswordUpdateViewModel } from "@/features/auth/viewmodel/useForcePasswordUpdateViewModel";
import styles from "./ForcePasswordUpdatePage.module.css";
import { Button } from "@/components/ui/Button";

export const ForcePasswordUpdateForm = () => {
  const { email, hasEmail, isLoading, handleResendLink, handleGoToLogin } =
    useForcePasswordUpdateViewModel();

  return (
    <div className={styles.authContainer}>
      <div className={styles.card}>
        <div className={styles.infoBox}>Your password needs to be updated before continuing.</div>

        <div className={styles.icon}>🔒</div>

        <h2>Update Your Password</h2>
        <p>For your security, please update your password to proceed further.</p>

        {hasEmail ? (
          <p className={styles.emailLine}>
            We will send a reset link to <span className={styles.emailValue}>{email}</span>
          </p>
        ) : (
          <p className={styles.emailMissing}>
            We could not load your email from this session. Please go back to sign in and try again.
          </p>
        )}

        <Button
          className={styles.secondaryBtn}
          onClick={handleResendLink}
          disabled={isLoading || !hasEmail}
        >
          {isLoading ? "Sending…" : "Resend Link"}
        </Button>

        <p className={styles.goToLoginHint}>
          If you have updated your password, you can sign in again.
        </p>

        <Button type="button" className={styles.goToLoginBtn} onClick={handleGoToLogin}>
          Go to Login
        </Button>
      </div>
    </div>
  );
};
